import { environment } from 'environments/environment';
import { EventEmitter, Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';

@Injectable({
  providedIn: 'root'
})
export class QueueHubService {
  private connection: signalR.HubConnection;
  public connectionExists: Boolean;
  public queueUpdateEvent = new EventEmitter<any>();

  constructor() {
    console.log('QueueHub Started...');
    this.connectionExists = false;

    // Создаем подключение к современному SignalR Hub
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(environment.api + 'electronicQueueHub', {
        transport: signalR.HttpTransportType.ServerSentEvents,
        withCredentials: false // Для CORS с credentials
      })
      .withAutomaticReconnect()
      .build();

    this.registerOnServerEvents();
  }

  public start(clubId: string) {
    this.startConnection(clubId).then();
  }

  private async startConnection(clubId: string): Promise<void> {
    if (this.connectionExists) {
      await this.connection.stop();
    }

    try {
      await this.connection.start();
      await this.connection.invoke('subscribeElectronicQueueHub', clubId);
      this.connectionExists = true;
    } catch (error) {
      console.error('*** Could not connect ' + error);
    }
  }

  private registerOnServerEvents(): void {
    // Удаляем старые обработчики и добавляем новые
    this.connection.off('ElectronicQueueUpdateEvent');
    this.connection.on('ElectronicQueueUpdateEvent', (res) => this.onUpdateEvent(res));
  }

  private onUpdateEvent(res) {
    this.queueUpdateEvent.emit(JSON.parse(res));
  }
}
